import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "개인정보 보호정책" }) => {
    return (
        <AnimationRevealPage>
            <Header />
            <Container>
                <ContentWithPaddingXl>
                    <HeadingRow>
                        <Heading>{headingText}</Heading>
                    </HeadingRow>
                    <Text>
                        <p>발효일: 2024년 3월 1일</p>

                        <p>
                            Red Falcon의 모든 게임에 오신 것을 환영합니다! Red Falcon Company는 귀하의 개인정보와 프라이버시 보호에 전념하고 있습니다. 본 개인정보 보호정책 계약은 Red Falcon의 모든 게임을 사용하는 동안 제공한 정보를 어떻게 수집, 사용, 보호하는지 설명합니다. 서비스를 사용하기 전에 이 계약을 주의 깊게 읽어주시기 바랍니다.
                        </p>

                        <p>
                            저희는 서비스 제공 및 개선을 위해 귀하의 개인정보를 사용합니다. 서비스를 사용함으로써 귀하는 본 개인정보 보호정책에 따라 정보의 수집 및 사용에 동의하는 것으로 간주됩니다.
                        </p>

                        <p>
                            저희 게임을 플레이해 주셔서 감사합니다! 본 개인정보 보호정책은 다음을 설명합니다:
                        </p>
                        <ul>
                            <li>
                                <p>
                                    귀하로부터 어떤 방식으로 개인 데이터를 수집하는지, 그리고 그 이유
                                </p>
                            </li>
                            <li>
                                <p>
                                    귀하의 개인 데이터를 어떻게 사용하는지
                                </p>
                            </li>
                            <li>
                                귀하의 개인 데이터에 대해 귀하가 선택할 수 있는 사항
                            </li>
                        </ul>
                        <p>
                            본 개인정보 보호정책은 Red Falcon의 게임, 스토어, 웹사이트 및 관련 서비스에 적용되며, 이를 통칭하여 서비스라고 부릅니다. 우리는 falcon-games.com에 새로운 버전을 게시함으로써 이 개인정보 보호정책을 주기적으로 업데이트할 수 있습니다. 중요한 변경 사항이 있을 경우, 해당 변경이 적용되기 전에 서비스 내 공지 또는 관련 법률에 따라 귀하에게 통지해드립니다. 발효일 이후에 서비스를 계속 사용할 경우, 새로운 개인정보 보호정책의 적용을 받게 됩니다.
                        </p>
                        
                        <h2>우리가 수집하는 데이터</h2>
                        <p>
                            우리가 수집하는 개인 데이터의 범주는 귀하가 사용하는 서비스와 해당 법률의 요구 사항에 따라 달라집니다.
                        </p>
                        <p>
                            귀하가 직접 제공한 데이터
                        </p>
                        <p>
                            ▪ 연락처 정보(예: 이메일 주소)
                        </p>
                        <p>
                            ▪ 플레이어 이름 또는 ID와 비밀번호
                        </p>
                        <p>
                            ▪ 프로필 정보(예: 프로필 사진)
                        </p>
                        <p>
                            ▪ 귀하가 서비스 사용 시 제출한 메시지 및 기타 콘텐츠(예: 채팅 로그 및 플레이어 지원 티켓)
                        </p>
                        <p>
                            ▪ 설문조사, 프로모션, 경품, 대회 및 기타 이벤트와 관련하여 제공된 데이터
                        </p>
                        <p>
                            ▪ Red Falcon 스토어를 통해 이루어진 구매와 관련하여 결제 서비스 제공업체가 귀하의 결제 정보를 수집합니다.
                        </p>
                        <h2>
                            자동으로 수집하는 데이터
                        </h2>
                        <p>
                            ▪ 귀하의 계정 및 게임 진행 상황에 관한 데이터(대부분의 경우 자동으로 생성된 내부 계정 ID 포함)
                        </p>
                        <p>
                            ▪ 귀하의 IP 주소 및 모바일 기기 식별자(예: 기기 또는 광고 ID)
                        </p>
                        <p>
                            ▪ 귀하의 기기에 대한 데이터(예: 기기 이름, 운영체제, 브라우저 유형 및 언어, 인터넷 서비스 제공업체, 이동통신사)
                        </p>
                        <p>
                            ▪ 쿠키 및 유사한 기술로 수집된 데이터(아래 참조)
                        </p>
                        <p>
                            ▪ 대략적인 위치 데이터(IP 주소에서 도출된 정보)
                        </p>
                        <p>
                            ▪ 귀하의 서비스 사용과 관련된 데이터(예: 게임 플레이 데이터, 구매 내역, 서비스 내 다른 플레이어와의 상호작용)
                        </p>
                        <p>
                            귀하는 이메일 주소 또는 다른 연락처 정보를 사용하여 Red Falcon ID를 생성할 수도 있습니다.
                        </p>
                        <h2>
                            파트너로부터 수집하는 데이터
                        </h2>
                        <p>
                            우리는 또한 소셜 네트워킹 사이트, 데이터 분석 제공업체 및 광고 네트워크와 같은 제3자 파트너를 사용하여 귀하에 대한 정보를 보완합니다. 예를 들어:
                        </p>
                        <p>
                            ▪ 제3자 도구를 서비스와 연결한 경우 수신하는 데이터(일부 시장에서는 LINE, WeChat 또는 Meta와 같은 서비스)
                        </p>
                        <p>
                            ▪ 인구통계 데이터(예: 귀하의 IP 주소에서 대략적인 위치를 파악하기 위한 데이터)
                        </p>
                        <p>
                            ▪ 사기 방지 데이터(예: 게임 내 환불 남용 또는 광고에서의 클릭 사기)
                        </p>
                        <p>
                            ▪ 게임이 실행되는 플랫폼 또는 결제 서비스 제공업체로부터의 데이터(예: 결제 확인 데이터)
                        </p>
                        <p>
                            ▪ 광고 및 분석 목적의 데이터(예: 설문조사)로 더 나은 서비스를 제공할 수 있도록 함
                        </p>
                        <p>
                            ▪ 귀하가 제3자 서비스에서 제공한 데이터(일부 시장에서는 LINE, WeChat 또는 Meta)를 귀하의 프라이버시 설정을 통해 제공받습니다.
                        </p>
                        <h2>
                            데이터를 수집하는 이유
                        </h2>
                        <p>
                            우리는 여러 비즈니스 목적으로 귀하의 데이터를 사용합니다. 예를 들어:
                        </p>
                        <p>
                            서비스를 정상적으로 운영하기 위해
                        </p>
                        <p>
                            계약을 이행하기 위해 필요한 데이터를 처리합니다:
                        </p>
                        <p>
                            ▪ 계정을 생성하고 게임을 플레이하며 서비스를 이용할 수 있도록 함
                        </p>
                        <p>
                            ▪ 서비스를 운영함
                        </p>
                        <p>
                            ▪ 결제를 확인하고 검증함
                        </p>
                        <p>
                            ▪ 요청하신 제품과 서비스를 제공하고 배송함
                        </p>
                        <p>
                            ▪ 서비스 관련 통신을 발송함
                        </p>
                        <h2>
                            플레이어에게 더 적합한 서비스를 제공하기 위해
                        </h2>
                        <p>
                            플레이어에게 훌륭한 서비스를 제공하기 위해, 우리는 다음과 같은 필요 데이터를 수집하고 처리하는 정당한 이익을 가지고 있습니다:
                        </p>
                        <p>
                            ▪ 플레이어 프로필을 업데이트하고 개발함
                        </p>
                        <p>
                            ▪ 서비스와 플레이어 경험을 개발하고 개선함
                        </p>
                        <p>
                            ▪ 귀하와의 관계를 관리함
                        </p>
                        <p>
                            ▪ 서비스의 일부로 소셜 기능을 제공함
                        </p>
                        <p>
                            ▪ 귀하의 서비스 경험을 맞춤화함
                        </p>
                        <p>
                            ▪ 귀하의 의견과 질문에 응답하고 플레이어 지원을 제공함
                        </p>
                        <p>
                            ▪ 서비스 내 및 기타 웹사이트와 서비스에서 Red Falcon의 제안을 제공함(이메일 포함)
                        </p>
                        <p>
                            ▪ 업데이트, 보안 경고 및 지원 메시지와 같은 관련 정보를 전송함
                        </p>
                        <p>
                            ▪ 다른 플레이어와의 소통을 가능하게 함
                        </p>
                        <h2>
                            맞춤형 광고를 표시하기 위해
                        </h2>
                        <p>
                            서비스 및 기타 장소(이메일 포함)에서 맞춤형 광고를 표시하기 위해, 우리는 필요한 데이터를 처리할 정당한 이익을 가지고 있습니다:
                        </p>
                        <p>
                            ▪ 귀하가 서비스와 관련하여 접근하는 콘텐츠와 온라인 행동을 추적함
                        </p>
                        <p>
                            ▪ 광고와 서비스를 제공, 타겟팅 및 개선함
                        </p>
                        <h2>
                            서비스를 안전하고 공정하게 유지하기 위해
                        </h2>
                        <p>
                            서비스에서 공정한 환경을 보장하는 것은 우리에게 최우선 사항입니다. Red Falcon 서비스 이용 약관에 관한 정보는 더 자세히 참고하십시오.
                        </p>
                        <p>
                            서비스를 안전하고 공정하게 유지하기 위해, 사기
                            와 부정행위를 방지하고, 기타 적절한 사용을 보장하기 위해, 우리는 필요한 데이터를 처리할 정당한 이익을 가지고 있습니다:
                        </p>
                        <p>
                            ▪ 서비스와 그 소셜 기능의 사용을 분석하고 모니터링함
                        </p>
                        <p>
                            ▪ 채팅을 자동 또는 수동으로 조정함
                        </p>
                        <p>
                            ▪ 사기 행위자 또는 문제를 일으키는 플레이어에 대해 조치를 취함
                        </p>
                        <h2>
                            데이터 분석, 프로파일링, 세분화하기 위해
                        </h2>
                        <p>
                            위의 모든 경우와 목적에서, 우리는 수집된 모든 데이터를 분석하고, 프로파일링하며, 세분화할 수 있습니다.
                        </p>
                        <h2>
                            귀하의 동의를 바탕으로
                        </h2>
                        <p>
                            귀하의 동의 하에, 우리는 추가적인 목적을 위해 귀하의 데이터를 처리할 수 있습니다.
                        </p>
                        <p>
                            우리는 또한 게임 내 광고를 표시하고 개인 맞춤형 광고를 제공하기 위해 귀하의 장치 식별자를 수집하고 사용할 수 있습니다. 적용 가능한 경우, 우리는 광고 식별자(IDFA, GAID), 공급업체 식별자, IP 주소, 장치 ID, 그리고 기타 장치 식별자(국가, 운영체제 버전, 장치 모델, 클라이언트 버전)와 같은 데이터를 수집할 수 있습니다. 일반 데이터 보호 규정(GDPR)을 포함한 해당 개인정보 보호법에 따라, 우리는 이를 수행하기 위해 귀하의 동의를 요구합니다.
                        </p>
                        <p>
                            이 데이터는 광고 파트너가 적절한 광고를 제공하고 광고 콘텐츠를 최적화하여 같은 광고가 여러 번 표시되지 않도록 귀하의 동의 하에 공유됩니다. 우리는 이러한 광고 전달과 맞춤화를 위해 선택된 파트너와 귀하의 장치 식별자를 공유합니다.
                        </p>
                        <p>
                            귀하는 게임 설정에서 동의를 관리하고, 장치 설정에서 광고 추적을 제한할 수 있습니다. 옵트아웃은 각 브라우저와 장치에 따라 다르며, 옵트아웃이 효과를 발휘하기까지 시간이 조금 걸릴 수 있음을 유의하십시오.
                        </p>
                        <p>
                            앱 내 모바일 광고의 경우, 귀하는 광고 식별자를 재설정하고, 귀하의 장치에 따라 관심 기반 광고를 옵트아웃하거나(Android), 광고 추적 제한 설정을 켤 수 있습니다(iOS).
                        </p>
                        <p>
                            파트너는 광고 네트워크 및 중재 플랫폼을 운영하며, 광고 인벤토리 입찰을 촉진하고 참여합니다. 파트너는 또한 합법적인 이익에 따라 사기 탐지를 위해 장치 식별자를 사용할 수 있습니다. 자세한 내용은 파트너의 개인정보 보호정책을 확인하십시오.
                        </p>
                        <p>ironSource 개인정보 보호정책: <a href="https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1"
                            rel="noopener noreferrer">https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1</a></p>
                        <p>Vungle 개인정보 보호정책: <a href="https://vungle.com/privacy/" target="_blank" rel="noopener noreferrer">https://vungle.com/privacy/</a></p>
                        <p>Google 개인정보 보호정책: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></p>
                        <p>Liftoff 개인정보 보호정책: <a href="https://liftoff.io/privacy-policy/" target="_blank" rel="noopener noreferrer">https://liftoff.io/privacy-policy/</a></p>
                        <p>Mintegral 개인정보 보호정책: <a href="https://www.mintegral.com/en/privacy" target="_blank" rel="noopener noreferrer">https://www.mintegral.com/en/privacy</a></p>
                        <p>Unity Ads 개인정보 보호정책: <a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://unity.com/legal/privacy-policy</a></p>
                        <p>Facebook 개인정보 보호정책: <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/privacy/policy/</a></p>
                        <p>Apple Search Ads: <a href="https://searchads.apple.com/privacy" target="_blank" rel="noopener noreferrer">https://searchads.apple.com/privacy</a></p>
                        <p>Applovin 개인정보 보호정책: <a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer">https://www.applovin.com/privacy/</a></p>
                        <p>inMobi 개인정보 보호정책: <a href="https://advertising.inmobi.com/privacy-policy" target="_blank" rel="noopener noreferrer">https://advertising.inmobi.com/privacy-policy</a></p>
                        <p>Pangle 개인정보 보호정책: <a href="https://www.pangleglobal.com/zh/privacy" target="_blank" rel="noopener noreferrer">https://www.pangleglobal.com/zh/privacy</a></p>
                        <p>DT Exchange 개인정보 보호정책: <a href="https://www.digitalturbine.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://www.digitalturbine.com/legal/privacy-policy</a></p>
                        <p>Chartboost 개인정보 보호정책: <a href="https://docs.chartboost.com/en/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://docs.chartboost.com/en/legal/privacy-policy</a></p>
                        <p>TapSDK 개인정보 보호정책: <a href="https://www.tapdb.com/tapsdk-privacy.html" target="_blank" rel="noopener noreferrer">https://www.tapdb.com/tapsdk-privacy.html</a></p>
                        <p>talkingdata 개인정보 보호정책: <a href="https://www.talkingdata.com/privacy.jsp" target="_blank" rel="noopener noreferrer">https://www.talkingdata.com/privacy.jsp</a></p>


                        <h2>누가 귀하의 데이터를 볼 수 있는가</h2>
                        <p>Red Falcon 외에도, 다음과 같은 상황에서 다른 사람들이 귀하의 데이터에 접근할 수 있습니다:</p>
                        <p>다른 플레이어와 사용자.</p>
                        <p>소셜 기능은 저희 게임의 핵심 구성 요소입니다. 예를 들어, 다른 플레이어와 사용자는 귀하의 프로필 데이터, 게임 내 활동 및 게시한 메시지를 볼 수 있습니다.</p>
                        <p>저희 서비스 제공업체.</p>
                        <p>Red Falcon은 서비스를 제공하는 데 도움을 주는 벤더가 있습니다. 이 벤더들은 Red Falcon의 지시에 따라 귀하의 데이터를 처리하며, 호스팅, 플레이어 지원, 광고, 분석 및 사기 방지와 같은 작업을 수행합니다.</p>
                        <p>다른 회사 및 공공 기관.</p>
                        <p>결제 확인(Paypal과 같은 결제 제공업체) 및 사기와 불법 활동을 방지하기 위해, 우리는 다른 회사 및 조직과 데이터를 처리하고, 법적 요청에 응하여 공공 기관에 데이터를 제공할 수 있습니다.</p>
                        <p>또한, 법적 요구를 준수하거나 우리, 우리 플레이어 또는 타인의 권리, 재산, 안전을 보호하기 위해 귀하의 동의에 따라 귀하의 데이터를 공개할 수 있습니다.</p>
                        <p>광고 및 소셜 미디어 파트너.</p>
                        <p>서비스에는 소셜 미디어 상호작용 도구, 애플리케이션 프로그래밍 인터페이스(API), 소프트웨어 개발 키트(SDK)를 통한 기능 및 게임 내 광고와 같은 파트너 기능이 포함되어 있습니다. 이러한 파트너 목록은 "귀하의 동의 하에" 섹션에 나와 있습니다. 이러한 파트너는 귀하의 데이터에 접근할 수 있으며, 그들의 개인정보 보호정책에 따라 운영됩니다. 그들의 데이터 처리 관행에 대해 자세히 알아보시려면 그들의 개인정보 보호정책을 확인하시기 바랍니다.</p>
                        <p>이 파트너들은 귀하의 활동 및 장치(예: IP 주소, 모바일 식별자, 방문한 페이지, 위치, 시간대)에 관한 데이터에 접근할 수 있습니다. 또한, 우리는 귀하에 대해 수집한 데이터를 제3자 광고 파트너와 결합하여 공유할 수 있습니다. 이러한 광고 파트너는 이러한 데이터를 사용하여, 제3자 서비스 내에서 귀하에게 타겟 광고를 제공할 수 있습니다. 이 파트너들은 그들의 개인정보 보호정책에 따라 운영됩니다. 이러한 관행은 일반적으로 "관심 기반 광고" 또는 "온라인 행동 광고"라고 합니다.</p>

                        <h2>국제 데이터 전송</h2>
                        <p>저희 서비스는 글로벌한 성격을 지니고 있으며, 따라서 귀하의 데이터는 전 세계 어디로든 전송될 수 있습니다. 각 국가의 데이터 보호법이 귀하의 국가와 다를 수 있으므로, 우리는 이 개인정보 보호정책에서 설명된 대로 귀하의 데이터를 보호하기 위한 적절한 보호 조치를 취합니다. 우리가 사용할 수 있는 적절한 보호 조치에는 EU 집행위원회가 승인한 표준 계약 조항 및 기타 합법적인 보호 조치가 포함됩니다.</p>

                        <h2>귀하의 권리와 선택</h2>
                        <p>마케팅 이메일 및 기타 직접 마케팅에서 옵트아웃하기.</p>
                        <p>적용 가능한 법률이 허용하는 경우, Red Falcon은 기존 고객 관계를 바탕으로 마케팅 커뮤니케이션을 보낼 수 있습니다.</p>
                        <p>귀하는 그러한 커뮤니케이션에 포함된 지침을 따르거나 게임 내 설정을 변경하여, 저희로부터 프로모션 커뮤니케이션(마케팅 이메일 등)을 받지 않도록 선택할 수 있습니다. 업데이트된 설정이 즉시 적용되지 않을 수 있습니다. 저희로부터 서비스 관련 커뮤니케이션, Red Falcon 서비스 약관 또는 본 개인정보 보호정책에 대한 업데이트, 또는 서비스에서의 구매와 관련된 거래 정보 등은 여전히 받으실 수 있음을 유의하십시오.</p>

                        <h2>푸시 알림</h2>
                        <p>우리는 모바일 애플리케이션을 통해 푸시 알림을 보낼 수 있습니다. 귀하는 모바일 장치의 설정을 변경하여 언제든지 이러한 유형의 커뮤니케이션 수신을 중단할 수 있습니다.</p>

                        <h2>타겟 광고에서 옵트아웃하기</h2>
                        <p>Android 또는 iOS 장치의 개인정보 보호 설정을 확인하고 "앱이 추적 요청을 허용하도록 설정"을 끄거나 "광고 추적 제한"(Apple iOS) 또는 "관심 기반 광고 옵트아웃"(Android)을 선택하여 모바일 애플리케이션에서 관심 기반 광고를 옵트아웃할 수 있습니다. 또한, 게임 설정에서 제공되는 옵션을 통해 개인화된 게임 내 제안을 옵트아웃할 수 있습니다(해당하는 경우).</p>

                        <p>우리가 보유한 귀하의 개인 데이터에 접근하기.</p>
                        <p>귀하의 요청이 있으면, 우리는 귀하의 개인 데이터를 전자 형식으로 제공할 것입니다.</p>

                        <h2>기타 권리</h2>
                        <p>귀하는 또한 귀하의 데이터를 수정하고, 귀하의 데이터를 삭제하고, 우리가 귀하의 데이터를 사용하는 방법에 대해 이의를 제기하거나 공유하는 방법을 제한할 권리가 있습니다. 귀하는 언제든지 귀하의 동의를 철회할 수 있습니다.</p>

                        <p>모든 요청에 합리적인 기간 내에 응답하겠습니다. 저희가 만족스럽게 해결하지 못한 미해결된 프라이버시 또는 데이터 사용 문제에 대해, 유럽 경제 지역, 스위스 또는 영국 내의 현지 데이터 보호 당국에 연락할 수도 있습니다.</p>

                        <p>위에서 설명한 데이터 주체 권리를 행사하고자 하는 경우, 위의 "Contact Us"에서 설명된 지원 옵션을 사용하십시오. 우리는 적용 법률에 따라 모든 요청에 응답할 것입니다. 귀하의 프라이버시를 보호하기 위해, 요청을 이행하기 전에 귀하의 신원을 확인하기 위한 추가 조치를 취할 수 있습니다. 예를 들어, 구매 영수증 또는 기타 계정 정보를 요청하거나, 귀하의 이메일 주소를 게임 계정과 연결하도록 요구하거나(예: 게임 ID를 통해), 서비스에서 귀하의 활동에 관한 질문에 답변하도록 요구할 수 있습니다. 신원이 확인되면, 해당 법률에 따라 귀하의 권리를 대신 행사할 권한이
                            있는 대리인을 지정할 수도 있습니다. 이를 위해 대리인의 연락처 정보를 고객 지원팀에 제공해 주시면 됩니다.
                        </p>
                        <p>
                            귀하는 이러한 권리를 행사한 결과로 차별적인 대우를 받지 않을 권리가 있습니다.
                        </p>
                        <h1>
                            귀하의 데이터를 어떻게 보호하는가
                        </h1>
                        <h2>
                            보안 조치
                        </h2>
                        <p>
                            안전하고 보호된 플레이어 경험을 보장하기 위해, 우리는 귀하의 데이터를 무단 접근, 손실, 오용 또는 변경으로부터 보호하기 위해 관리적, 기술적, 물리적 보안 조치를 지속적으로 개발하고 실행하고 있습니다.
                        </p>
                        <h2>
                            데이터 보존
                        </h2>
                        <p>
                            우리는 귀하의 계정이 활성 상태인 동안 또는 귀하에게 서비스를 제공하는 데 필요한 동안 귀하의 데이터를 보존합니다. 예를 들어, 사용되지 않는 게임 계정을 주기적으로 비식별화하거나, 불필요한 데이터를 정기적으로 검토하고 비식별화할 수 있습니다.
                            귀하가 귀하의 개인 데이터를 삭제해 달라고 요청한 경우, 법적 의무를 준수하고 분쟁을 해결하며 계약을 이행하는 등 정당한 비즈니스 이익을 위해 필요한 경우 귀하의 데이터를 계속 보유할 수 있습니다.
                        </p>
                        <h1>
                            어린이
                        </h1>
                        <p>
                            온라인에서 어린이의 프라이버시를 보호하는 것은 우리에게 매우 중요한 일입니다. 일반적으로 우리의 서비스는 13세 미만의 어린이(또는 해당 지역 법률에 의해 요구되는 나이)를 대상으로 하지 않으며, 서비스는 의도적으로 어린이로부터 개인 데이터를 수집하지 않습니다. 다만, 다음 단락에 설명된 경우는 예외입니다.
                        </p>
                        <p>
                            어린이를 대상으로 하지 않는 게임이지만 어린이에게 매력적일 수 있는 경우, 우리는 플레이어의 연령에 따라 이러한 서비스에 대한 접근을 제한하는 추가적인 조치를 취합니다. 이러한 서비스의 경우, 플레이어가 13세 미만(또는 해당 지역의 적용되는 연령)임을 나타내면 소셜 미디어 및 채팅 기능을 비롯한 특정 기능에 대한 접근을 제한하고, 특정 유형의 알림 경고도 제한합니다. 또한, 우리는 서비스의 내부 운영을 지원하는 데 필요한 범위 내에서만 개인 데이터를 처리합니다.
                        </p>
                        <p>
                            일부 서비스의 경우, 위에서 설명한 두 단락보다 높은 연령 제한(예: 16세)을 사용할 수 있습니다. 이는 우리 플레이어에게 안전한 게임 경험을 제공하고, 젊은 플레이어를 보호하기 위함입니다.
                        </p>
                        <p>
                            귀하가 부모나 보호자인 경우, 귀하의 자녀로부터 수집된 개인 데이터를 검토하거나 해당 정보를 수정하거나 삭제하고자 할 경우, 상기된 "Contact Us" 섹션에 기재된 방법으로 저희에게 연락하실 수 있습니다. 만약 우리가 어린이가 위의 규정에 반하여 개인 데이터를 제공했다는 사실을 인지한 경우, 우리는 수집된 모든 개인 데이터를 삭제하고, 법적 의무에 따라 데이터를 보유해야 할 경우를 제외하고, 어린이의 계정을 해지하거나 해당되는 경우 미성년자용 경험으로 되돌릴 것입니다.
                        </p>
                        <h1>
                            캘리포니아 주민을 위한
                        </h1>
                        <p>
                            다음 섹션은 캘리포니아 거주자에게만 적용됩니다.
                        </p>
                        <h2>
                            1) 데이터 수집
                        </h2>
                        <p>
                            지난 12개월 동안 우리가 수집한 개인 데이터의 범주와 해당 데이터의 출처는 "우리가 수집하는 데이터" 섹션에서 설명하고 있습니다.
                        </p>
                        <h2>
                            2) 데이터 사용
                        </h2>
                        <p>
                            귀하의 개인 데이터를 수집하는 비즈니스 또는 상업적 목적은 "우리가 귀하의 데이터를 수집하는 이유" 섹션에 설명되어 있습니다.
                        </p>
                        <h2>
                            3) 데이터 공개 및/또는 판매
                        </h2>
                        <p>
                            우리는 일반적인 의미에서 이해되는 방식으로 제3자에게 귀하의 개인 데이터를 "판매"하지 않습니다. 그러나, 우리는 관심 기반 광고를 제공하고, 설치를 속성화하며, 캠페인 성과를 최적화하기 위해 제3자 광고 플랫폼과 귀하의 쿠키 정보 및 광고 식별자를 공유할 수 있습니다. 이러한 관행이 캘리포니아 소비자 보호법(CCPA)에 따라 "판매"로 간주되는 경우, 귀하는 "타겟 광고에서 옵트아웃하기" 섹션에 설명된 단계를 따름으로써 해당 공유를 옵트아웃할 수 있습니다.
                        </p>
                        <p>
                            우리는 16세 미만의 미성년자의 개인 데이터 판매에 대한 실제적인 지식이 없습니다. 이 용어는 CCPA에 정의된 "판매"를 기준으로 합니다.
                        </p>
                        <p>
                            지난 12개월 동안, 우리는 우리 서비스의 일환으로 다음 범주의 개인 데이터를 공개했습니다:
                        </p>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>수집된 개인 데이터 범주</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>Red Falcon이 수집한 데이터 예시</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>업무 목적으로 개인 데이터를 받을 수 있는 제3자 범주</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>식별자</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>실명, 별명, 고유 개인 식별자, 온라인 식별자, 인터넷 프로토콜 주소, 이메일 주소, 계정 이름 또는 기타 유사한 식별자.</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>다른 플레이어(사용자 이름 및 프로필만), 서비스 제공자, 비즈니스 파트너, 광고 네트워크(광고 식별자 및 IP 주소만)</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>캘리포니아 고객 기록 법령(Cal. Civ. Code § 1798.80(e))에 나열된 개인 데이터 범주</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>이름 또는 전화번호.</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>서비스 제공자</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>캘리포니아 또는 연방법에 따른 보호 분류 특성</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>나이.</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>서비스 제공자, 광고 네트워크(준수 목적만)</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>상업 정보</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>구매, 획득 또는 고려된 제품 또는 서비스 기록, 기타 구매 또는 소비 이력 또는 경향.</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>서비스 제공자, 광고 네트워크</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>인터넷 또는 기타 전자 네트워크 활동</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>브라우징 기록, 인터넷 웹사이트, 애플리케이션 또는 광고와의 소비자 상호 작용에 대한 정보.</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>서비스 제공자, 광고 네트워크</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>다른 개인 데이터에서 추론된 소비자 프로필</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>소비자의 선호도, 특성 및 행동을 반영한 프로필.</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>서비스 제공자</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            위에서 설명한 공유 외에도, 우리는 귀하로부터 수집한 모든 정보를 우리 계열사와 공유할 수 있으며, 이는 우리 또는 타인을 보호하기 위한 것이거나, 합병, 매각, 또는 기타 자산 양도가 발생할 경우에 해당됩니다. 자세한 내용은 “누가 귀하의 데이터를 볼 수 있는가” 섹션을 참조하십시오.
                        </p>
                        <h2>
                            4) 귀하의 권리
                        </h2>
                        <p>
                            캘리포니아 법률에 따른 귀하의 권리는 “귀하의 권리와 선택” 섹션에서 설명되어 있습니다.
                        </p>
                        <h1>
                            터키 거주자를 위한
                        </h1>
                        <p>
                            발효일: 2022년 6월 1일
                        </p>
                        <p>
                            다음 섹션은 터키 공화국 내에 위치한 데이터 주체에게 적용됩니다.
                        </p>
                        <h2>
                            1) 데이터 수집 및 처리
                        </h2>
                        <p>
                            귀하의 개인 데이터는 데이터 보호법, 특히 터키 개인 데이터 보호법 제6698호(“DPL”)에 따라 처리됩니다.
                        </p>
                        <p>
                            우리가 수집한 개인 데이터의 범주 및 해당 데이터의 출처는 글로벌 개인정보 보호정책의 “우리가 수집하는 데이터” 섹션에 설명되어 있습니다.
                        </p>
                        <p>
                            귀하의 개인 데이터를 수집하는 목적은 “우리가 귀하의 데이터를 수집하는 이유” 섹션에 설명되어 있습니다. 위에 더하여, 귀하의 개인 데이터는 다음과 같은 DPL에 따른 법적 근거를 바탕으로 자동으로 수집 및 처리됩니다:
                        </p>
                        <p>
                            ▪ 제5조 2항 (f)
                        </p>
                        <p>
                            ▪ 제5조 2항 (c)
                        </p>
                        <p>
                            ▪ 제5조 1항
                        </p>
                        <h2>
                            2) 귀하의 권리
                        </h2>
                        <p>
                            귀하는 DPL 제11조에 명시된 법적 권리를 가지고 있으며, 이는 우리가 보유하고 있는 귀하의 개인 정보와 관련됩니다. 터키 공화국에서 서비스를 이용하는 데이터 주체로서, 귀하는 데이터 관리자에게 다음과 같은 권리를 행사할 수 있습니다(적용되는 법률 및 규정에 따라 허용되는 범위 내에서):
                        </p>
                        <p>
                            1. 귀하의 개인 데이터가 처리되고 있는지 여부를 알 권리,
                        </p>
                        <p>
                            2. 귀하의 개인 데이터가 처리되었는지 여부에 관한 정보를 요구할 권리,
                        </p>
                        <p>
                            3. 귀하의 개인 데이터 처리 목적을 알고, 해당 데이터가 목적에 맞게 사용되고 있는지 확인할 권리,
                        </p>
                        <p>
                            4. 귀하의 개인 데이터가 국내 또는 해외의 제3자에게 이전된 상황을 알 권리,
                        </p>
                        <p>
                            5. 불완전하거나 부정확한 데이터가 있을 경우 이를 수정할 것을 요청할 권리,
                        </p>
                        <p>
                            6. DPL 제7조에 명시된 조건에 따라 귀하의 개인 데이터를 삭제하거나 파기할 것을 요청할 권리,
                        </p>
                        <p>
                            7. 귀하의 개인 데이터가 이전된 제3자에게 (e) 및 (f)항에 따라 수행된 작업의 보고를 요청할 권리,
                        </p>
                        <p>
                            8. 자동 시스템만을 통해 처리된 데이터를 분석하여 자신에게 불리한 결과가 발생하는 것에 대해 이의를 제기할 권리,
                        </p>
                        <p>
                            9. 귀하의 개인 데이터가 불법적으로 처리되어 발생한 손해에 대한 보상을 청구할 권리.
                        </p>
                        <h1>
                            한국 거주자를 위한
                        </h1>
                        <p>
                            개인정보의 파기
                        </p>
                        <p>
                            당사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
                        </p>
                        <p>
                            정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 처리 목적이 제한되도록 해당 개인정보를 분리합니다.
                        </p>
                        <p>
                            법령에 의해 일정기간 보관되어야 하는 개인정보 및 해당 법령은 다음과 같습니다.
                        </p>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>관련 법령</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>수집 정보</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>보유기간</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }} rowSpan="2">통신비밀보호법</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>서비스 이용 관련 정보(웹사이트 방문기록)</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>3개월</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>3년</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }} rowSpan="2">전자상거래 등에서의 소비자 보호에 관한 법률</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>계약 또는 청약철회 등에 관한 기록</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>5년</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>대금결제 및 재화 등의 공급에 관한 기록</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>5년</td>
                                </tr>
                            </tbody>
                        </table>

                        <p>
                            개인정보 파기의 절차 및 방법은 다음과 같습니다.
                        </p>
                        <p>
                            ▪ 파기절차: 당사는 파기 사유가 발생한 개인정보를 선정하고, 당사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
                        </p>
                        <p>
                            ▪ 파기방법: 당사는 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 그 외 기록, 인쇄 자료, 서면, 또는 기록 장치의 경우 분쇄기로 분쇄하거나 소각하여 파기합니다.
                        </p>
                        <p>
                            개인정보의 국외 수집
                        </p>
                        <p>
                            당사는 귀하의 개인정보를 국외에서 수집하여 처리하고 있습니다.
                        </p>
                        <p>
                            ▪ 귀하의 개인정보는 EU/EEA 지역 및 미국 내에 물리적으로 저장됩니다.
                        </p>
                        <h2>
                            개인정보의 국외 이전
                        </h2>
                        <p>
                            다음과 같이 귀하의 개인정보가 국외에 이전됩니다.
                        </p>
                        <p>
                            ▪ 국외이전의 법적 근거 : 개인정보 보호법 제28조의8 제1항 제3호 가목(계약이행을 위한 국외 처리위탁・보관)
                        </p>
                        <p>
                            ▪ 개인정보를 이전받는 자 :
                            <a href="mailto:aws-korea-privacy@amazon.com">Amazon Web Services, Inc. (aws-korea-privacy@amazon.com)</a>,
                            <a href="mailto:googlekrsupport@google.com">Google Cloud Platform (googlekrsupport@google.com)</a>
                        </p>

                        <p>
                            ▪ 이전되는 개인정보 항목 : 본 방침에 기재된 수집항목 일체
                        </p>
                        <p>
                            ▪ 이전되는 국가 : 미국
                        </p>
                        <p>
                            ▪ 이전 일시/방법 : 네트워크를 통해 수시로
                        </p>
                        <p>
                            ▪ 이전받는 자의 개인정보 이용목적: 클라우드를 통한 고객정보 보관
                        </p>
                        <p>
                            ▪ 이전받는 자의 개인정보 보유ㆍ이용 기간 : 본 방침에 기재된 보유기간 범위 내에서 당사와의 계약 종료 시까지
                        </p>
                        <p>
                            귀하의 개인정보를 해외로 이전하는 것을 원하지 않는 경우, 법무 부서에 문의하십시오(개인 정보 보호 정책의 문의처 섹션 참조). 그러나 모든 개인정보가 그러하듯이 플레이어가 수집한 정보는 귀하가 개인 정보의 해외 전송을 거부하는 경우 Red Falcon Ltd 로 전송됩니다. 데이터가 있는 경우 당사는 귀하에게 서비스를 제공하지 못할 수도 있습니다.
                        </p>
                        <h2>
                            개인정보 처리방침의 변경
                        </h2>
                        <p>
                            이 개인정보 처리방침은 2024.03.01.부터 적용됩니다.
                        </p>
                        <h2>문의하기</h2>
                        <p>
                            데이터 보호에 관한 질문이 있거나 귀하의 개인정보와 관련된 문제 해결을 위한 요청이 있는 경우, 각 Red Falcon 게임 내 지원 기능을 통해 주로 연락해 주시기 바랍니다. 그럴 경우 더 빠르게 답변드릴 수 있습니다. 또는 아래 연락처로 문의하실 수 있습니다:
                        </p>

                        <p>
                            담당자 이름: Red Falcon Games Limited.
                        </p>
                        <p>
                            주소: 중국 저장성 항저우시 위항구 창첸 가도시대티안위안청 19동 6층 601-2호
                        </p>
                        <p>
                            주의: 개인정보 보호
                        </p>
                        <p>
                            이메일: support@falcon-games.com
                        </p>
                    </Text>
                </ContentWithPaddingXl>
            </Container>
            <Footer />
        </AnimationRevealPage>
    );
};
